<!--
 * @Author: your name
 * @Date: 2020-05-27 17:26:02
 * @LastEditTime: 2020-06-18 10:51:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\website\src\views\about\newscontent.vue
-->
<template>
  <div class="yqh_newsContent">
    <div class="newsContent">
      <!-- 面包屑 -->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link to="/Aboutus/company">关于我们</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <router-link to="/Aboutus/news">新闻中心</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>文章详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 面包屑 end-->
      <div class="newscenter">
        <!-- 新闻内容 -->
        <div class="content">
          <h1 class="content_title">{{detail.title}}</h1>
          <p class="time" style="margin-top:20px">{{detail.create_time}}</p>
          <div class="image_text ql-editor" v-html="detail.content" style="margin-top:20px"></div>
          <div class="button">
            <div class="left">
              <el-link
                @click="go_pre"
                :underline="false"
              >上一篇:{{pre?pre.title.substring(0,15)+'....':'已经是第一篇'}}</el-link>
            </div>
            <div class="right">
              <el-link
                @click="go_next"
                :underline="false"
              >下一篇:{{next?next.title.substring(0,15)+'....':'已经是最后一篇'}}</el-link>
            </div>
          </div>
        </div>
        <!-- 新闻内容 end-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: "",
      pre: "",
      next: "",
      id: this.$route.query.id,
      is_top: this.$route.query.is_top
    };
  },
  components: {},
  methods: {
    getNewDetail() {
      let that = this;
      let id = that.id;
      let is_top = that.is_top;
      if (!id || !is_top) {
        that.$message.error("获取新闻详情失败");
        return;
      }
      let formData = new FormData();
      formData.append("id", id);
      formData.append("is_top", is_top);
      that.$http
        .post("website/getNewsDetails", formData)
        .then(function(res) {
          if (res.data.errorCode == 200) {
            that.detail = res.data.newDetail;
            that.pre = res.data.preDetail;
            that.next = res.data.nextDetail;
            that.detail.create_time = new Date(
              that.formatIosDate(that.detail.create_time)
            ).Format("yyyy-MM-dd hh:mm:ss");
          } else {
            that.$message.error(res.data.errorMsg);
          }
        })
        .catch(function(e) {
          // console.log(e);
        });
    },
    go_pre() {
      if (this.pre) {
        this.id = this.pre.id;
        this.is_top = this.pre.is_top;
        this.getNewDetail();
      }
      return;
    },
    go_next() {
      if (this.next) {
        this.id = this.next.id;
        this.is_top = this.next.is_top;
        this.getNewDetail();
      }
      return;
    }
  },
  created() {
    this.getNewDetail();
  }
};
</script>
<style lang='less'>
.yqh_newsContent {
  width: 100%;
  .newsContent {
    width: 1110px;
    margin: 0 auto;
    padding: 40px 0;
    box-sizing: border-box;
    .breadcrumb {
      width: 100%;
      color: #666666;
      font-size: 14px;
      .el-icon-arrow-right {
        margin: 0;
      }
    }
    .newscenter {
      width: 100%;
      margin: 0 auto;
      .content {
        width: 100%;
        margin: 0 auto;

        .content_title {
          margin-top: 50/16rem;
          line-height: 60px;
          color: #333333;
          font-size: 30px;
          text-align: center;
        }
        .time {
          color: #999999;
          font-size: 15px;
          margin-top: 10px;
          // text-align:center;
          margin-left: 220px;
        }
        .image {
          margin: 0 auto;

          img {
            max-width: 100%;
          }
        }
        .text_content {
          color: #333333;

          font-size: 16px;
          line-height: 24px;
          margin-bottom: 30px;
        }
        .button {
          margin-top: 80/16rem;
          display: flex;
          justify-content: space-between;
          // a {
          //   text-decoration: none;
          //   color: #999999;
          //   font-size: 15px;
          // }
        }
        .image_text {
          width: 810px;
          overflow: hidden;
          // text-align: center;
          margin: 0 auto;
          img{
            width: 100%;
            // height: 100%;
          }
        }
      }
    }
  }
}
</style>

